import { render, staticRenderFns } from "./RoomEncrypted.vue?vue&type=template&id=2fe17674&"
import script from "./RoomEncrypted.vue?vue&type=script&lang=js&"
export * from "./RoomEncrypted.vue?vue&type=script&lang=js&"
import style0 from "./RoomEncrypted.vue?vue&type=style&index=0&id=2fe17674&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports